import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Loader2, MailX } from 'lucide-react';

export default function BulkUnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [status, setStatus] = useState<'loading' | 'valid' | 'already' | 'invalid' | 'done'>('loading');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    supabase.functions.invoke('bulk-email-unsubscribe', { body: { token } })
      .then(({ data }) => setStatus(data?.status ?? 'invalid'));
  }, [token]);

  const confirm = async () => {
    setBusy(true);
    const { data } = await supabase.functions.invoke('bulk-email-unsubscribe', { body: { token, confirm: true } });
    setBusy(false);
    setStatus(data?.status ?? 'invalid');
  };

  const text: Record<string, string> = {
    valid: '¿Quieres dejar de recibir los comunicados de LÍDER IA? Seguirás recibiendo los correos de tu cuenta (acceso, contraseña y avisos).',
    already: 'Ya habías dejado de recibir los comunicados.',
    invalid: 'Este enlace no es válido o ha expirado.',
    done: 'Listo. Ya no recibirás más comunicados.',
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardContent className="space-y-4 p-8 text-center">
          <MailX className="mx-auto h-10 w-10 text-primary" />
          <h1 className="text-xl font-bold">Comunicados LÍDER IA</h1>
          {status === 'loading' ? <Loader2 className="mx-auto h-6 w-6 animate-spin" /> : <p className="text-muted-foreground">{text[status]}</p>}
          {status === 'valid' && (
            <Button onClick={confirm} disabled={busy}>{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Confirmar</Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
